import React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { incrementStep, decrementStep, setFormData } from '../../redux/actions';
import { BackArrow } from "../../../shared/svgIcons.jsx";
import ShingleLineSelect from '../../../shared/ShingleLineSelect'

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #D40F7D;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 18px;
  padding: .5rem;
  width: 100%;
  margin-top: 1.5rem;
  :disabled {
    background-color: #D8D8D8;
    cursor: default;
  }
`;


const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: .5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;


const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);
// TODO, fetch real shingle lines and colors
var shingleLines = ['', 'Test Line'];
var shingleColors = ['', 'Test Color'];

const ContractorStep10 = ( { incrementStep, decrementStep, formData } ) => {
  const validated = (formData.shingleLine && formData.shingleColor);

  return(
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 11 - can you describe the type of shingles"
        onClick={decrementStep}>
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>
          What is the type of property where the roof was installed?
        </BackText>
      </BackWrapper>
      <IntroMessage>
        Next, we’re going to ask a few questions about the products you installed.
      </IntroMessage>
      <Header>Can you describe the type of shingles you installed?</Header>
      <ShingleLineSelect />
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 11 - can you describe the type of shingles"
        onClick={incrementStep} disabled={!validated}>Next</NextButton>
    </StepWrapper>
  )
};

const mapDispatchToProps = dispatch => (
  {
    incrementStep: () => dispatch(incrementStep()),
    decrementStep: () => dispatch(decrementStep()),
    setFormData: (hash) => dispatch(setFormData(hash)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorStep10);
